const SEARCH_OUTPUT = {
  PREAPPROVAL_MPL_APPROVED_WITH_LEADGEN: 1,
  PREAPPROVAL_MPL_REFUSED_WITH_LEADGEN: 2,
  MPL_REFUSED_WITH_LEADGEN: 3,
  PREAPPROVAL_WITHOUT_MPL_WITH_LEADGEN: 4,
  WITHOUT_MPL_LEADGEN_ONLY: 5,
  WITHOUT_MPL_WITHOUT_LEADGEN: 6,
} as const;

export type TAnalyticsSearchOutput = (typeof SEARCH_OUTPUT)[keyof typeof SEARCH_OUTPUT];

export type TGetAnalyticsSearchOutputParams = {
  hasMplPreApproval: boolean | undefined;
  hasLeadGen: boolean | undefined;
  isAvailableMpl: boolean | undefined;
  hasApprovedMpl: boolean | undefined;
  isAllRefusedMpl: boolean | undefined;
};

export const getAnalyticsSearchOutput = ({
  hasMplPreApproval,
  hasLeadGen,
  isAvailableMpl,
  hasApprovedMpl,
  isAllRefusedMpl,
}: TGetAnalyticsSearchOutputParams): TAnalyticsSearchOutput => {
  if (isAvailableMpl) {
    if (hasMplPreApproval && hasApprovedMpl && hasLeadGen) {
      return SEARCH_OUTPUT.PREAPPROVAL_MPL_APPROVED_WITH_LEADGEN;
    }

    if (hasMplPreApproval && isAllRefusedMpl && hasLeadGen) {
      return SEARCH_OUTPUT.PREAPPROVAL_MPL_REFUSED_WITH_LEADGEN;
    }

    if (isAllRefusedMpl && hasLeadGen) {
      return SEARCH_OUTPUT.MPL_REFUSED_WITH_LEADGEN;
    }
  }

  if (!isAvailableMpl) {
    if (hasMplPreApproval && hasLeadGen) {
      return SEARCH_OUTPUT.PREAPPROVAL_WITHOUT_MPL_WITH_LEADGEN;
    }

    if (hasLeadGen) {
      return SEARCH_OUTPUT.WITHOUT_MPL_LEADGEN_ONLY;
    }

    return SEARCH_OUTPUT.WITHOUT_MPL_WITHOUT_LEADGEN;
  }

  return SEARCH_OUTPUT.WITHOUT_MPL_WITHOUT_LEADGEN;
};
